import axios from "axios";

import { store } from '../storeConfig';

import { logout, loginDataAction } from "./Login/loginActions";

import APIConfig from "./APIConfig";
import appConstants from "../appConstants";
import * as AppUtils from '../Utils/AppUtils';

// Every API request
axios.interceptors.request.use
(
	(req) => 
	{
		req.baseURL = AppUtils.getApiBaseUrl();

		if(req.headers.Authorization == "")
		{
			var token = (AppUtils.getSessionStorageData(appConstants.USER_SESSION_KEY) ? AppUtils.getSessionStorageData(appConstants.USER_SESSION_KEY).token : "");
			req.headers.Authorization = token;
		}
		return req
	},
	(error) => 
	{
		console.log("Error in API request", error)
	}
);

// Every API response
axios.interceptors.response.use
(
	(res) => 
	{ 
		return res;
	},
	(error) => 
	{
		var errorResponse = error.response;
		// User will be redirected to login screen if session expires
		if (errorResponse.status == APIConfig.FORBIDDEN_STATUS_CODE) 
		{
			var loginData = {};
			var userSessionExpiredStatus = true;
			var loginStatus = false;
			AppUtils.saveSessionStorageData(appConstants.USER_SESSION_EXPIRED_STATUS, userSessionExpiredStatus);
			store.dispatch(logout(loginStatus));
			AppUtils.removeSessionStorageData(appConstants.USER_SESSION_KEY);
			store.dispatch(loginDataAction(loginData));
			AppUtils.removeSessionStorageData(appConstants.SAML_VALIDATION_DETAILS_SESSION_KEY);
		}
	}
);

export function postMethod(postURL, headers, bodyObj, cb, responseType) 
{
	axios
		.post(postURL, bodyObj, { headers: headers, responseType: responseType ? responseType : 'json' })
		.then(function (response) 
		{
			cb(response);
		})
		.catch((error) => 
		{
			var errorResponse = { errorOccured: true };
			cb(errorResponse);
		});
}

export function getMethod(getURL, headers, cb) 
{
	axios
		.get(getURL, { headers: headers })
		.then(function (response) 
		{
			cb(response);
		})
		.catch((error) => 
		{
			var errorResponse = { errorOccured: true };
			cb(errorResponse);
		});
}

export function putMethod(putURL, headers, bodyObj, cb) 
{
	axios
		.put(putURL, bodyObj, { headers: headers })
		.then(function (response) 
		{
			cb(response);
		})
		.catch((error) => 
		{
			var errorResponse = { errorOccured: true };
			cb(errorResponse);
		});
}